import { render, staticRenderFns } from "./RequestEditTabApprovals.vue?vue&type=template&id=fcd2ed2a&scoped=true&"
import script from "./RequestEditTabApprovals.vue?vue&type=script&lang=js&"
export * from "./RequestEditTabApprovals.vue?vue&type=script&lang=js&"
import style0 from "./RequestEditTabApprovals.vue?vue&type=style&index=0&id=fcd2ed2a&lang=scss&scoped=true&"
import style1 from "./RequestEditTabApprovals.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd2ed2a",
  null
  
)

export default component.exports